import React, {ReactElement, ReactNode} from 'react';
import {Container, Wrapper} from './style';
import {Compensator} from 'components/Button';

interface HeaderProps {
  children?: ReactNode;
}

export const Header = ({children}: HeaderProps): ReactElement => {
  return (
    <Wrapper>
      <Compensator>
        <Container>{children}</Container>
      </Compensator>
    </Wrapper>
  );
};
